import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button } from "reactstrap";
import axios from 'axios';
import { blogApiURL } from "../globalVariables";

const Careers = () => {

  const [careersData, setCareersData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isNoOpening, setIsNoOpening] = useState(false);
      
  useEffect(() => {
      
    const fetchCareersData = async () => {

        setLoading(true);
        
        try {
            
            // get blog list for readtimes and other metadata
            const res = await axios.get(`${blogApiURL}/list`, {
                params: {'type': 'careers'}
            }
            );
            setCareersData(res?.data || []);
            if (res?.data.length === 0){
              setIsNoOpening(true);
            }                
        } catch (error) {
            console.error('Error fetching blog data:', error);
        } finally {
            setLoading(false);
        }
    };

    fetchCareersData();

}, []);

  // Function to handle the apply button click
  const handleApplyClick = (url) => {
    window.open(url, "_blank");
  };

  return (
    <section className="section" id="careers">
      <Container>
        <Row className="justify-content-center">
          <Col lg={8}>
            <div className="header-title text-center">
              <p className="text-uppercase text-muted mb-2">CAREERS</p>
              <h3 className="text-uppercase">Join Our Team</h3>
              <div className="title-border mt-3"></div>
              <p className="text-muted mt-3">
                Explore exciting career opportunities at Citra. Apply now to be part of our innovative team!
              </p>
              {(!loading && isNoOpening)  && <p className="text-muted mt-3">
                No job openings at the momment!
              </p> }
            </div>
          </Col>
        </Row>

        {(!loading && !isNoOpening)  ? (
          <Row 
            className="mt-5" 
            style={{
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: 'center',
              width: '100%',
            }}
          >
            {careersData.map((job, index) => (
              <div 
                key={index} 
                className="career-box p-4 box-shadow d-flex justify-content-between align-items-center"
                style={{
                  width: '80%',
                  marginBottom: '20px',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  backgroundColor: '#fff',
                }}
              >
                {/* Left Side: Title and Job Info */}
                <div style={{ textAlign: 'left' }}>
                  <h5 className="fs-18 mb-2">{job.title}</h5>
                  <p className="text-muted mb-0">
                    {job.department} | {job.type} | {job.location}
                  </p>
                </div>

                {/* Right Side: Apply Button */}
                <Button 
                  color="primary" 
                  onClick={() => handleApplyClick(job.url)}
                  className="mt-0"
                  style={{
                    alignSelf: 'flex-start'
                  }}
                >
                  Apply Now
                </Button>
              </div>
            ))}
          </Row>
        ) : null}
      </Container>
    </section>
  );
};

export default Careers;
